import BarleyProduct from 'models/BarleyProduct'

export const packagingInitialState = {
  category: BarleyProduct.category,
  subCategory: BarleyProduct.subCategory,
  GrainSize: '',
  BarleyVerification: false,
  Organic: false,
}
